<template>
  <div>
    <a href="https://colabear92.github.io/nexontest/">
  <div class="container">
  
  <div class="left">    
    <img src="../assets/nexon.png" style="width: 150px;">
</div>    
<div class="right">
  <h2>넥슨 테스트</h2>
  <p>"넥슨 게임에 대해 얼마나 알고있나요?"</p>
</div>

</div>
</a>

<hr style="margin-left:50px; margin-right:50px; margin-bottom: 20px;">
<a href="https://colabear92.github.io/appletest/">
  <div class="container">
  
  <div class="left">    
    <img src="../assets/apple.png" style="width: 100px;">
</div>    
<div class="right">
  <h2>앱등이 테스트</h2>
  <p>"나는 Apple에 얼마나 빠져 있을까?"</p>
</div>

</div>
</a>

<hr style="margin-left:50px; margin-right:50px; margin-bottom: 20px;">
<a href="https://colabear92.github.io/fire/">
  <div class="container">
  
  <div class="left">    
    <img src="../assets/fire.png" style="width: 100px;">
</div>    
<div class="right">
  <h2>퇴사 테스트</h2>
  <p>"회사 다니기 싫은데.. 나는 퇴사해야 할까?"</p>
</div>

</div>
</a>

<hr style="margin-left:50px; margin-right:50px; margin-bottom: 20px;">
<a href="https://colabear92.github.io/somegirl/">
  <div class="container">
  
  <div class="left">    
    <img src="../assets/somegirl.png" style="width: 100px;">
</div>    
<div class="right">
  <h2>👬썸녀 테스트💗</h2>
  <p>"이 여자가 나의 연인이 될 수 있는 썸녀일까?"</p>
</div>

</div>
</a>

<hr style="margin-left:50px; margin-right:50px; margin-bottom: 20px;">
<a href="https://colabear92.github.io/someboy/">
  <div class="container">
  
  <div class="left">    
    <img src="../assets/someboy.png" style="width: 100px;">
</div>    
<div class="right">
  <h2>👬썸남 테스트💗</h2>
  <p>"이 남자가 나의 미래 연인이 될 수 있는 썸남일까?"</p>
</div>
<div class="footer"></div>

</div>
</a>

<hr style="margin-left:50px; margin-right:50px; margin-bottom: 20px;">


  </div>
</template>

<script>
export default {

}
</script>

<style>
a{
  text-decoration: none;
  color:black;
}
.container{
  width: 100%;
  max-width: 440px;
  height: 150px;
  /* border: 1px solid #c7c7c7;
  border-radius: 5px; */
  /* border-top: none;
  border-bottom: none; */
  
  }
.left{
    width: 30%;
    height: 150px;
    /* background: cornflowerblue; */
    float:left;
    
}
.right{
    width: 70%;
    height: 150px;
    /* background: coral; */
    float:left;
}
.footer{
  width: 100%;
    clear: both;
}


</style>